const Orientation = Object.freeze({
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
});

export default Orientation;
